import classNames from 'classnames'
import React from 'react'

type PropTypes = {
  className?: string,
  children: React.ReactNode
}

const HeaderCell = ({ className, children }: PropTypes) => {
  return (
    // Why applying the padding to the header row wasn't working is beyond me
    <th className={classNames('first:pl-[15px] last:pr-[15px] pt-3 pb-3.5 text-xs leading-[14.4px] font-medium text-start text-black-1000 bg-gray-50', className)}>
      {children}
    </th>
  )
}

export default HeaderCell
